module.exports = __webpack_public_path__ + "99afce5e44bcc982c9933476dfc7dc3c.MP3";